import {contextify, createRootContextHook} from 'common/util/react';
import {EventDefinitionsResource} from 'common/report/model-resources/event-definitions';

const context = contextify<EventDefinitionsResource>();

export const EventDefinitionsProvider = context.Provider;
export const EventDefinitionsConsumer = context.Consumer;
export const useEventDefinitions = createRootContextHook(`eventDefinitions`);
